import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../core'

// { address: 'john.doe@example.com', type: 'work', preferred: false, verified: false, note: '' },
export const RESOURCE = {
  payload: {
    description: 'Information about email address',
    name: 'Email Address',
    partialId: PartialId.Standard.create('email_address'),
  },
  type: core.quiver.Resource.Type.DmsStructure,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsStructure>
